export default {
  executive_dashboard: 'Management Insights',
  aggregated_stores_view: 'Aggregated Stores View',
  pricing_management: 'Pricing Management',
  advertising_center: {
    title: 'Advertising Center',
    children: {
      dashboard: 'Dashboard',
      analytics: 'Analytics',
      rule_parameters: 'Rule Parameters',
      reports: 'Reports',
    },
  },
  reimbursement: {
    title: 'Reimbursement',
    children: {
      analytics: 'Reimbursement Analytics',
    },
  },
  inventory_management: {
    title: 'Inventory Management',
    children: {
      replenishment: 'Replenishment',
      inventory_health_report: 'Inventory Health Report',
      returns_management: 'Returns Management',
      receive_orders: 'Receive Orders',
      eva_3pl_inventory: 'EVA 3PL Inventory',
    },
  },
  integrations: 'Integrations',
  search_product: 'Search Product',
  settings: 'Settings',
  help: 'Help',
};
